import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { baseCss } from "../common/css";
import HeaderNonSrp from "../header/headerNonSrp";
import SubHeader from "../header/subHeader";
import Footer from "../footer/footer";

import GInput from "../common/input/ginput";
import { renderImg } from "../common/icons/img";
import { Search } from "../common/icons/svg";

import Alert from "../common/alert";
import { apiUrl } from "../common/constants";
import { fetchGet } from "../../common/common";

import {
  t,
  SELECT_STARTING_STATE,
  SELECT_DESTINATION_STATE,
  BUS_TIME_TABLE,
  ST_STATE,
  ST_CITY,
  SEARCH_STARTING_STATE,
  SEARCH_STARTING_CITY,
  SEARCH_DESTINATION_STATE,
  DE_STATE,
  DE_CITY,
  SEARCH_DESTINATION_CITY,
  VIEW_TIME_TABLE
} from "../../translations/BusTimeTable";

const index = (props) => {
  const { history } = props;

  const [staticCityList, setStaticCityList] = useState(false);
  const [stateData, setStateData] = useState(false);
  const [frToCityData, setFrToCityData] = useState(false);

  const [showDropFrState, setShowDropFrState] = useState(false);
  const [frStateSearchText, setFrStateSearchText] = useState("");
  const [frStateData, setFrStateData] = useState(false);
  const [frStateList, setFrStateList] = useState(false);
  const [selFrState, setSelFrState] = useState({ id: 0, name: "" });

  const [showDropFrCity, setShowDropFrCity] = useState(false);
  const [frCitySearchText, setFrCitySearchText] = useState("");
  const [frCityData, setFrCityData] = useState(false);
  const [frCityList, setFrCityList] = useState(false);
  const [selFrCity, setSelFrCity] = useState({ id: 0, name: "" });

  const [showDropToState, setShowDropToState] = useState(false);
  const [toStateSearchText, setToStateSearchText] = useState("");
  const [toStateData, setToStateData] = useState(false);
  const [toStateList, setToStateList] = useState(false);
  const [selToState, setSelToState] = useState({ id: 0, name: "" });

  const [showDropToCity, setShowDropToCity] = useState(false);
  const [toCitySearchText, setToCitySearchText] = useState("");
  const [toCityData, setToCityData] = useState(false);
  const [toCityList, setToCityList] = useState(false);
  const [selToCity, setSelToCity] = useState({ id: 0, name: "" });

  const [errMsg, setErrorMsg] = useState("");

  //for update default list and click event
  useEffect(() => {
    window.addEventListener("click", (e) => {
      if (e.target.className === "timetable--wrapper") {
        setShowDropFrState(false);
        setShowDropFrCity(false);
        setShowDropToState(false);
        setShowDropToCity(false);
      }
    });
  }, []);

  //for update default list and click event
  useEffect(() => {
    const url = window.cdnUrl + apiUrl.getStaticCity;

    fetchGet(url)
      .then(function (response) {
        if (response.success) {
          const staticCityList = response.data;
          const stateData = response.stateData;

          if (stateData) {
            let fromStateData = [];
            let toStateData = [];

            Object.keys(stateData).forEach((frStateId, index) => {
              //for create from state array
              Object.keys(staticCityList).forEach((el) => {
                if (staticCityList[el].StateID == frStateId) {
                  if (
                    fromStateData.find((el) => el.id == frStateId) == undefined
                  ) {
                    fromStateData.push({
                      id: staticCityList[el].StateID,
                      name: staticCityList[el].StateName,
                    });
                  }
                }
              });

              //for first from state create tostate array
              if (index == 0) {
                stateData[frStateId].forEach((toStateId) => {
                  Object.keys(staticCityList).forEach((el2) => {
                    if (staticCityList[el2].StateID == toStateId) {
                      if (
                        toStateData.find((el3) => el3.id == toStateId) ==
                        undefined
                      ) {
                        toStateData.push({
                          id: staticCityList[el2].StateID,
                          name: staticCityList[el2].StateName,
                        });
                      }
                    }
                  });
                });
              }
            });

            //from state
            setFrStateList(fromStateData);
            setFrStateData(fromStateData);

            //to state
            setToStateList(toStateData);
            setToStateData(toStateData);

            let fromCityData = [];
            let toCityData = [];

            Object.keys(staticCityList).forEach((el) => {
              fromCityData.push({
                id: staticCityList[el].ID,
                name: staticCityList[el].Name,
              });
            });

            setFrCityData(fromCityData);
            setFrCityList(fromCityData);

            Object.keys(staticCityList).forEach((el) => {
              toCityData.push({
                id: staticCityList[el].ID,
                name: staticCityList[el].Name,
              });
            });

            setToCityData(toCityData);
            setToCityList(toCityData);

            setStaticCityList(staticCityList);
            setStateData(stateData);
          }

          //for call 2nd api
          getCityList(staticCityList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  //for filter state name from state list
  useEffect(() => {
    if (frStateData.length > 0) {
      const tempList = frStateData.filter((el) => {
        return el.name.toLowerCase().includes(frStateSearchText.toLowerCase());
      });
      setFrStateList(tempList);
    }
  }, [frStateSearchText]);

  useEffect(() => {
    if (frCityData.length > 0) {
      const tempList = frCityData.filter((el) => {
        return el.name.toLowerCase().includes(frCitySearchText.toLowerCase());
      });
      setFrCityList(tempList);
    }
  }, [frCitySearchText]);

  useEffect(() => {
    if (toStateData.length > 0) {
      const tempList = toStateData.filter((el) => {
        return el.name.toLowerCase().includes(toStateSearchText.toLowerCase());
      });
      setToStateList(tempList);
    }
  }, [toStateSearchText]);

  useEffect(() => {
    if (toCityData.length > 0) {
      const tempList = toCityData.filter((el) => {
        return el.name.toLowerCase().includes(toCitySearchText.toLowerCase());
      });
      setToCityList(tempList);
    }
  }, [toCitySearchText]);

  const loadStateFrCityDropList = (el) => {
    if (el && el.id) {
      let fromCityData = [];
      Object.keys(frToCityData).forEach((key) => {
        if (el.id == frToCityData[key].stateId) {
          fromCityData.push({
            id: frToCityData[key].cityId,
            name: frToCityData[key].cityName,
          });
        }
      });

      setFrCityData(fromCityData);
      setFrCityList(fromCityData);
      setSelFrCity({ id: 0, name: "" });
    }
  };

  const loadToCityDropList = (el) => {
    if (el && el.id) {
      let toCityData = [];
      Object.keys(frToCityData).forEach((key) => {
        if (el.id == frToCityData[key].cityId) {
          if (frToCityData[key].toCityList.length > 0) {
            frToCityData[key].toCityList.forEach((toCityObj) => {
              toCityData.push({ id: toCityObj.id, name: toCityObj.name });
            });
          }
        }
      });

      setToCityData(toCityData);
      setToCityList(toCityData);
      setSelToState({ id: 0, name: "" });
    }
  };

  const loadStateToCityDropList = (el) => {
    if (el && el.id && selFrState.id) {
      let toCityData = [];

      Object.keys(frToCityData).forEach((key) => {
        if (frToCityData[key].stateId == selFrState.id) {
          if (frToCityData[key].toCityList.length > 0) {
            frToCityData[key].toCityList.forEach((toCityObj) => {
              if (el.id == toCityObj.sid) {
                if (
                  toCityData.find((el3) => el3.id == toCityObj.id) == undefined
                ) {
                  toCityData.push({ id: toCityObj.id, name: toCityObj.name });
                }
              }
            });
          }
        }
      });

      setToCityData(toCityData);
      setToCityList(toCityData);

      setSelToCity({ id: 0, name: "" });
    }
  };

  const loadToStateDropList = (el) => {
    if (el && el.id) {
      const toStateIdArray = stateData[el.id];

      let toStateData = [];

      Object.keys(toStateIdArray).forEach((keys) => {
        Object.keys(staticCityList).forEach((keys2) => {
          if (staticCityList[keys2].StateID == toStateIdArray[keys]) {
            if (
              toStateData.find((el3) => el3.id == toStateIdArray[keys]) ==
              undefined
            ) {
              toStateData.push({
                id: staticCityList[keys2].StateID,
                name: staticCityList[keys2].StateName,
              });
            }
          }
        });
      });

      setToStateList(toStateData);
      setToStateData(toStateData);
      setSelToState({ id: 0, name: "" });
    }
  };

  const getCityList = (staticCityList) => {
    const that = this;
    const url = window.cdnUrl + apiUrl.getCityList;

    fetchGet(url)
      .then(function (cityResponse) {
        if (cityResponse.success) {
          const cityResData = cityResponse.data;

          let fromCityData = [];
          let toCityData = [];
          let frToCityData = [];
          let firstFromCityId = 0;
          let index = 0;

          Object.entries(cityResData).forEach(([frCityId, toCitiesArr]) => {
            const tempToCityArr = [];

            toCitiesArr.forEach((toCityId) => {
              Object.entries(staticCityList).forEach(([j, stToCity]) => {
                if (stToCity.ID == toCityId) {
                  tempToCityArr.push({
                    id: stToCity.ID,
                    name: stToCity.Name,
                    sid: stToCity.StateID,
                    sn: stToCity.StateName,
                  });
                }
              });
            });

            Object.entries(staticCityList).forEach(([i, stCity]) => {
              if (stCity.ID == frCityId) {
                frToCityData[index] = {
                  cityId: stCity.ID,
                  cityName: stCity.Name,
                  stateId: stCity.StateID,
                  stateName: stCity.StateName,
                  toCityList: tempToCityArr,
                };

                fromCityData.push({ id: stCity.ID, name: stCity.Name });
              }
            });

            if (firstFromCityId == 0) {
              firstFromCityId = frCityId;
              toCityData = tempToCityArr;
            }

            index++;
          });

          setFrToCityData(frToCityData);
          // console.log("frToCityData", frToCityData);

          setFrCityData(fromCityData);
          setFrCityList(fromCityData);

          setToCityData(toCityData);
          setToCityList(toCityData);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const openDropFrState = () => {
    setShowDropFrState(true);
    setShowDropFrCity(false);
    setShowDropToState(false);
    setShowDropToCity(false);
  };

  const openDropFrCity = () => {
    setShowDropFrState(false);
    setShowDropFrCity(true);
    setShowDropToState(false);
    setShowDropToCity(false);
  };

  const openDropToState = () => {
    setShowDropFrState(false);
    setShowDropFrCity(false);
    setShowDropToState(true);
    setShowDropToCity(false);
  };

  const openDropToCity = () => {
    setShowDropFrState(false);
    setShowDropFrCity(false);
    setShowDropToState(false);
    setShowDropToCity(true);
  };

  //for select state from list
  const handleSelectStState = (el) => {
    setSelFrState(el);
    setShowDropFrState(false);
    loadStateFrCityDropList(el);
    loadToStateDropList(el);
  };

  const handleSelectStCity = (el) => {
    setSelFrCity(el);
    setShowDropFrCity(false);
    loadToCityDropList(el);
  };

  const handleSelectToState = (el) => {
    setSelToState(el);
    setShowDropToState(false);
    loadStateToCityDropList(el);
  };

  const handleSelectToCity = (el) => {
    setSelToCity(el);
    setShowDropToCity(false);
  };

  const getTimeTableDetail = () => {
    if (selFrState.id == 0 && selFrState.name == "") {
      setErrorMsg(t(SELECT_STARTING_STATE));
      return false;
    }

    if (selToState.id == 0 && selToState.name == "") {
      setErrorMsg(t(SELECT_DESTINATION_STATE));
      return false;
    }

    const url = `/time_table/result?frStateId=${selFrState.id}&toStateId=${selToState.id}&frCityId=${selFrCity.id}&toCityId=${selToCity.id}`;
    history.push(url);
  };

  return (
    <div className="timetable--wrapper">
      <HeaderNonSrp />
      <SubHeader />
      <div className="timetable--inputs">
        <div
          style={{
            color: "#202020",
            fontWeight: "600",
            fontSize: "16px",
            lineHeight: "24px",
            letterSpacing: "0.01rem",
          }}
        >
          {t(BUS_TIME_TABLE)}
        </div>

        <div className="timetable-input-wrap">
          <GInput
            type="text"
            value={selFrState.name}
            errMsg={t(SELECT_STARTING_STATE)}
            label={t(ST_STATE)}
            key={"ststate"}
            icon={renderImg("tt-start-icon")}
            icon2={renderImg("tt-down-arrow")}
            onClick={() => openDropFrState(true)}
            onIconClick={() => openDropFrState(true)}
            readonly={true}
            mandatory={true}
          />
          <div
            className={showDropFrState ? "all-data-opt active" : "all-data-opt"}
          >
            <div className="sel-input-wrap">
              <div className="srch-icn">
                <Search />{" "}
              </div>
              <input
                type="text"
                placeholder={t(SEARCH_STARTING_STATE)}
                value={frStateSearchText}
                onChange={(e) => setFrStateSearchText(e.target.value)}
              />
              <span
                className="net-drop-up"
                onClick={() => setShowDropFrState(false)}
              ></span>
            </div>
            <div className="show-all-data scroll">
              {Object.values(frStateList).map((el, index) => {
                return (
                  <div
                    key={el + "-" + index}
                    className={
                      el.name === selFrState.name
                        ? " data--list active "
                        : " data--list "
                    }
                    onClick={() => handleSelectStState(el)}
                  >
                    {el.name}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="timetable-input-wrap">
          <GInput
            type="text"
            value={selFrCity.name}
            errMsg="Select Starting City"
            label={t(ST_CITY)}
            key={"stcity"}
            icon={renderImg("tt-start-icon")}
            icon2={renderImg("tt-down-arrow")}
            onClick={() => openDropFrCity(true)}
            onIconClick={() => openDropFrCity(true)}
            readonly={true}
            mandatory={false}
          />
          <div
            className={showDropFrCity ? "all-data-opt active" : "all-data-opt"}
          >
            <div className="sel-input-wrap">
              <div className="srch-icn">
                <Search />{" "}
              </div>
              <input
                type="text"
                placeholder={t(SEARCH_STARTING_CITY)}
                value={frCitySearchText}
                onChange={(e) => setFrCitySearchText(e.target.value)}
              />
              <span
                className="net-drop-up"
                onClick={() => setShowDropFrCity(false)}
              ></span>
            </div>
            <div className="show-all-data scroll">
              {Object.values(frCityList).map((el, index) => {
                return (
                  <div
                    key={el + "-" + index}
                    className={
                      el.name === selFrCity.name
                        ? " data--list active "
                        : " data--list "
                    }
                    onClick={() => handleSelectStCity(el)}
                  >
                    {el.name}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="timetable-input-wrap">
          <GInput
            type="text"
            value={selToState.name}
            errMsg={t(SEARCH_DESTINATION_STATE)}
            label={t(DE_STATE)}
            key={"destate"}
            icon={renderImg("tt-end-icon")}
            icon2={renderImg("tt-down-arrow")}
            onClick={() => openDropToState(true)}
            onIconClick={() => openDropToState(true)}
            readonly={true}
            mandatory={true}
          />
          <div
            className={showDropToState ? "all-data-opt active" : "all-data-opt"}
          >
            <div className="sel-input-wrap">
              <div className="srch-icn">
                <Search />{" "}
              </div>
              <input
                type="text"
                placeholder={t(SEARCH_DESTINATION_STATE)}
                value={toStateSearchText}
                onChange={(e) => setToStateSearchText(e.target.value)}
              />
              <span
                className="net-drop-up"
                onClick={() => setShowDropToState(false)}
              ></span>
            </div>
            <div className="show-all-data scroll">
              {Object.values(toStateList).map((el, index) => {
                return (
                  <div
                    key={el + "-" + index}
                    className={
                      el.name === selToState.name
                        ? " data--list active "
                        : " data--list "
                    }
                    onClick={() => handleSelectToState(el)}
                  >
                    {el.name}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="timetable-input-wrap">
          <GInput
            type="text"
            value={selToCity.name}
            errMsg="Select Destination City"
            label={t(DE_CITY)}
            key={"tocity"}
            icon={renderImg("tt-start-icon")}
            icon2={renderImg("tt-down-arrow")}
            onClick={() => openDropToCity(true)}
            onIconClick={() => openDropToCity(true)}
            readonly={true}
            mandatory={false}
          />
          <div
            className={showDropToCity ? "all-data-opt active" : "all-data-opt"}
          >
            <div className="sel-input-wrap">
              <div className="srch-icn">
                <Search />{" "}
              </div>
              <input
                type="text"
                placeholder={t(SEARCH_DESTINATION_CITY)}
                value={toCitySearchText}
                onChange={(e) => setToCitySearchText(e.target.value)}
              />
              <span
                className="net-drop-up"
                onClick={() => setShowDropToCity(false)}
              ></span>
            </div>
            <div className="show-all-data scroll">
              {Object.values(toCityList).map((el, index) => {
                return (
                  <div
                    key={el + "-" + index}
                    className={
                      el.name === selToCity.name
                        ? " data--list active "
                        : " data--list "
                    }
                    onClick={() => handleSelectToCity(el)}
                  >
                    {el.name}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div
          className="btn view-time-table"
          style={baseCss.secondaryBackground}
          onClick={getTimeTableDetail}
        >
          {t(VIEW_TIME_TABLE)}
        </div>
      </div>

      {errMsg && (
        <Alert msg={errMsg} error={true} close={() => setErrorMsg("")} />
      )}

      <Footer />
    </div>
  );
};

export default withRouter(index);
